import { get } from 'lodash';
import { Record } from '@xbcb/shared-schema';

export const getRecordCreatedTime = (record: Record): string => {
  return get(record, 'created.time');
};
